module.exports = __webpack_public_path__ + "static/media/control-points-pic4.92e3eb5a.svg";